var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "overlay-fade" } }, [
    _vm.visibility.overlay
      ? _c(
          "div",
          {
            ref: "overlay",
            class: _vm.overlayClass,
            attrs: {
              "aria-expanded": _vm.visible.toString(),
              "data-modal": _vm.name
            }
          },
          [
            _c(
              "div",
              {
                class: _vm.backgroundClickClass,
                on: {
                  mousedown: function($event) {
                    $event.stopPropagation()
                    return _vm.onBackgroundClick($event)
                  },
                  touchstart: function($event) {
                    $event.stopPropagation()
                    return _vm.onBackgroundClick($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "v--modal-top-right" },
                  [_vm._t("top-right")],
                  2
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: _vm.transition } }, [
                  _vm.visibility.modal
                    ? _c(
                        "div",
                        {
                          ref: "modal",
                          class: _vm.modalClass,
                          style: _vm.modalStyle,
                          on: {
                            mousedown: function($event) {
                              $event.stopPropagation()
                            },
                            touchstart: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _vm._t("default"),
                          _vm._v(" "),
                          _vm.resizable && !_vm.isAutoHeight
                            ? _c("resizer", {
                                attrs: {
                                  "min-width": _vm.minWidth,
                                  "min-height": _vm.minHeight
                                },
                                on: { resize: _vm.onModalResize }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }